import { render, staticRenderFns } from "./LopayWidget.vue?vue&type=template&id=3686e69b"
import script from "./LopayWidget.vue?vue&type=script&lang=js"
export * from "./LopayWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports